import React from 'react';
import { observer } from 'mobx-react';
import * as mobx from 'mobx';

// Config variables
import { config } from '../../config';

// Translations
import translate from '../Translate.js';


// Components
import ScheduleFields from '../Modules/ScheduleFields';
import ProctorGroupList from '../Modules/ProctorGroupList';
import AutomatedSettings from './AutomatedSettings';
import AutomatedSettingsV3 from './AutomatedSettingsV3';
import { handleSwitchInputKeys } from '../../helpers/helpers';
import { FeatureFlag } from 'react-launch-darkly';

// the proctor types V3 is enabled for...
const V3_PROCTOR_TYPES = [
  'TS63dda27a6ba54c218449b934b7bb1ba8', // auto
  'TS9531c6b112f145018dae3cd2a9f60c4c', // r&r
  'TS4b894875d26194988853e490dfb9bc41', // live
  'TS6d6011935f4646848ea4f7a29b4f61a5', // vtc
]

const EditProctorSettings = observer(class EditProctorSettings extends React.Component {
  constructor() {
    super();
    this.handleProctorChange = this.handleProctorChange.bind(this);
    this.renderLocations = this.renderLocations.bind(this);
    this.enabledDefaultChecked = false;
  }

  componentWillMount() {
    const { exam, customConfiguration, enrollmentConfig } = this.props;
    
    if(enrollmentConfig) {
      if(this.props.configuration.sid) {
        this.state = {
          proctorDate: null,
          proctorTypes: mobx.toJS(this.props.configuration.proctorTypes),
          configuration: this.props.configuration
        }
      } else {
        this.state = {
          proctorDate: null,
          proctorTypes: [],
          configuration: {
            proctorTypes: []
          }
        }
      }
    } else {
      if(typeof exam !== 'undefined' && exam.sid && !customConfiguration) {
        this.state = {
          proctorDate: null,
          proctorTypes: mobx.toJS(exam.configuration.proctorTypes),
          configuration: exam.configuration
        }
      } else if(customConfiguration) {
        this.state = {
          proctorDate: null,
          proctorTypes: mobx.toJS(customConfiguration.proctorTypes),
          configuration: customConfiguration
        }
      } else {
        this.state = {
          proctorDate: null,
          proctorTypes: [],
          configuration: exam.configuration
        }
      }
    }

    // Add any required proctor types to the state
    if(!this.props.crossListed) {
      this.checkProctorTypes();
    }
  }

  checkProctorTypes() {
    const { SessionStore } = this.props.store;
    const { exam } = this.props;

    // Add any required proctor types and remove any proctor types that have been disabled
    let proctorTypes = this.state.proctorTypes;

    SessionStore.proctorTypeList.forEach((parentType, i) => {
      // Make sure virtual proctors aren’t allowed for written
      if(
        exam &&
        exam.type &&
        exam.type.toLowerCase() === 'written' &&
        parentType.title.toLowerCase().indexOf('virtual') > -1
      ) {
        return '';
      }

      parentType.subCategories.forEach((subType, j) => {
        if(subType.status === 'required' && proctorTypes.indexOf(subType.sid) < 0) {
          proctorTypes.push(subType.sid);
        } else if(subType.status === 'disabled' && proctorTypes.indexOf(subType.sid) >= 0) {
          proctorTypes.splice(proctorTypes.indexOf(subType.sid), 1);
        } else if(subType.status === 'enabled-default' && proctorTypes.indexOf(subType.sid) < 0) {
          proctorTypes.push(subType.sid);
        }

      })
    });

    this.props.handleInput('proctorTypes', null, true, null, null, false, this.state.proctorTypes);
  }

  handleProctorChange(date) {
    this.setState({
      proctorDate: date
    });
  }

  handleProctorType(e) {
    let proctorTypes = this.state.proctorTypes;

    if(e.target.checked) {
      proctorTypes.push(e.target.value);

      if(e.target.value === config.instructorProctorTypeSid) {
        if(this.props.enrollmentConfig) {
          this.props.store.EnrollmentStore.addLocation();
        } else {
          this.props.store.ExamStore.addLocation();
        }
      }
    } else {
      const index = proctorTypes.indexOf(e.target.value);
      proctorTypes.splice(index, 1);

      if(e.target.value === config.instructorProctorTypeSid) {
        if(this.props.enrollmentConfig) {
          this.props.store.EnrollmentStore.removeLocation();
        } else {
          this.props.store.ExamStore.removeLocation();
        }
      }
    }

    this.setState({
      proctorTypes
    });

    this.props.handleInput('proctorTypes', e, true, null, null, false, this.state.proctorTypes);
  }

  renderLocations(render) {
    const { exam, customConfiguration } = this.props;

    if(render && this.state.proctorTypes.indexOf(config.instructorProctorTypeSid) > -1) {
      if(typeof exam !== 'undefined' && !customConfiguration) {
        const instructorAsProctor = this.props.store.ExamStore.exam.configuration.instructorAsProctor;

        return (
          <div className="schedule-wrap">
            {instructorAsProctor.map(
              (key, i) =>
              <ScheduleFields
                key={i}
                index={i}
                instructorAsProctor={instructorAsProctor}
                parent={this}
                exam={exam}
                {...this.props}
              />
            )}
          </div>
        );
      } else {
        let instructorAsProctor = []

        if(this.props.enrollmentConfig) {
          instructorAsProctor = this.props.store.EnrollmentStore.enrollmentConfiguration.instructorAsProctor;
        } else {
          instructorAsProctor = this.props.store.ExamStore.configuration.instructorAsProctor;
        }

        return (
          <div className="schedule-wrap">
            {instructorAsProctor.map(
              (key, i) =>
              <ScheduleFields
                key={i}
                index={i}
                {...this.props}
                instructorAsProctor={instructorAsProctor}
                parent={this}
              />
            )}
          </div>
        );
      }
    }

    return '';
  }

  isDisabled() {
    if(this.props.exception || this.props.readonly) {
      return true;
    }

    return false;
  }

  handleEnabledDefault = (subKey) => {
    const { exam, newExam } = this.props;

    if(!this.enabledDefaultChecked && subKey.status === 'enabled-default' && newExam) {
      exam.configuration.proctorTypes.push(subKey.sid);
    }

    this.enabledDefaultChecked = true;
  }

  renderv3Options(categorySid) {
    // Render V3 specific options here
    return (
      <AutomatedSettingsV3
          {...this.props}
          categorySid={categorySid}
        />)
  }

  renderAutomatedSettings(categorySid) {

    if(V3_PROCTOR_TYPES.indexOf(categorySid) > -1 
      && this.props.store.ExamStore.exam 
      && this.props.store.ExamStore.exam.platformVersion === 3) {
      if (['TS4b894875d26194988853e490dfb9bc41', 'TS6d6011935f4646848ea4f7a29b4f61a5'].includes(categorySid)) {
        return (  
        <FeatureFlag
          flagKey="enable-v-3-for-live"
          renderFeatureCallback={(version) => this.renderv3Options(categorySid)}
          renderDefaultCallback={() => <AutomatedSettings
                                          {...this.props}
                                          categorySid={categorySid}
                                        />}
        />
      );
      } else {
        return this.renderv3Options(categorySid);
      }      
    }else{
      return (
        <AutomatedSettings
          {...this.props}
          categorySid={categorySid}
        />
      );
    }
  }

  render() {
    const { automatedOnly, translation } = this.props;
    const { SessionStore } = this.props.store;
    const _this = this;
    let { exam } = this.props;

    function subCategoryLength(subCategories) {
      let enabledSubcategories = subCategories.filter(function(subCategory){
        if(_this.props.enrollmentConfig) {
          return subCategory.status !== 'disabled' && subCategory.sid !== config.instructorProctorTypeSid;
        } else {
          return subCategory.status !== 'disabled';
        }
      });

      if (enabledSubcategories.length > 0) {
        return true;
      }

      return false;
    }

    if(!this.props.crossListed) {
      if(SessionStore.proctorTypeList.length > 0) {
        return(
          <fieldset id="proctor-settings">
            <p className='note note--full note--full-alt proctor-type-instructions'>
              {translation.proctor_types.instructions}
            </p>
            {SessionStore.proctorTypeList.map(
              (key, i) =>
              {
                if(subCategoryLength(key.subCategories)) {
                  // If this is a written exam, don’t show
                  // virtual proctor types
                  if(
                    exam &&
                    exam.type &&
                    exam.type.toLowerCase() === 'written' &&
                    key.title.toLowerCase().indexOf('virtual') > -1
                  ) {
                    return '';
                  }

                  // HACK
                  // Handle virtual differently for Itawamba CC
                  if(
                    key.title.toLowerCase().indexOf('virtual') > -1 &&
                    SessionStore.userData.installSid === 'AI807436b2359f4debb339111bd4f788c2'
                  ) {
                    if(
                      SessionStore.userData.role.toLowerCase() === 'administrator' &&
                      this.props.exception
                    ) {
                      return (
                        <div className="form-subgroup" key={i}>
                          <strong className="form-subheading proctor-type-heading">{key.title}</strong>

                          {subCategoryLength(key.subCategories)}

                          <ul className="switch-list">
                            {key.subCategories.map(
                              (subKey, j) =>
                                {
                                  if(subKey.status === 'disabled' || (subKey.sid === config.instructorProctorTypeSid && this.props.enrollmentConfig)) {
                                    // Return nothing if this type is disabled
                                    // or if this is an enrollment configuration
                                    // and the type is instructor as proctor
                                    return '';
                                  } else {
                                    // Otherwise return a switch field
                                    return (
                                      <li key={j} className={`${this.props.defaultDiff('proctorTypes')} ${subKey.sid === config.instructorProctorTypeSid ? 'instructor' : ''} proctor-type-subcategory`}>
                                        <label htmlFor={subKey.sid} className="proctor-type-subcategory-label">{subKey.title}</label>

                                        <input
                                          type="checkbox"
                                          id={subKey.sid}
                                          className="switch-input"
                                          value={subKey.sid}
                                          defaultChecked={this.state.configuration.proctorTypes.indexOf(subKey.sid) > -1 || subKey.status === 'required'}
                                          onChange={(e) => {this.handleProctorType(e)}}
                                          disabled={subKey.status === 'required' || this.props.readonly}
                                          onKeyDown={handleSwitchInputKeys}
                                        />

                                        <label className="switch-label" htmlFor={subKey.sid}><span className="meta">{subKey.title}</span></label>

                                        {this.props.renderDefault('configuration.proctorTypes', null, true, subKey.sid)}

                                        {/* If this is an instuctor field, include the location form */}
                                        {this.renderLocations(subKey.sid === config.instructorProctorTypeSid)}

                                        {/* If automated, include the settings view */}
                                        {
                                          config.automatedProctorTypeSids.indexOf(subKey.sid) > -1 &&
                                          (
                                            this.state.configuration.proctorTypes.indexOf(subKey.sid) > -1 ||
                                            subKey.status === 'required'
                                          ) &&

                                          this.renderAutomatedSettings(subKey.sid)

                                        }
                                      </li>
                                    )
                                  }
                                }
                            )}
                          </ul>
                        </div>
                      )
                    }

                    return '';
                  }
                  // End HACK

                  return (
                    <div className="form-subgroup" key={i}>
                      {!automatedOnly &&
                        <strong className="form-subheading proctor-type-heading">{key.title}</strong>
                      }

                      {!automatedOnly && subCategoryLength(key.subCategories)}

                      <ul className="switch-list">
                        {key.subCategories.map(
                          (subKey, j) =>
                            {
                              if(
                                subKey.status === 'disabled' ||
                                (subKey.sid === config.instructorProctorTypeSid && this.props.enrollmentConfig) ||
                                (automatedOnly && config.automatedProctorTypeSids.indexOf(subKey.sid) === -1)
                              ) {
                                // Return nothing if this type is disabled
                                // or if this is an enrollment configuration
                                // and the type is instructor as proctor
                                return '';
                              } else {
                                // Otherwise return a switch field
                                return (
                                  <li key={j} className={`${this.props.defaultDiff('proctorTypes')} ${subKey.sid === config.instructorProctorTypeSid ? 'instructor' : ''} proctor-type-subcategory`}>
                                    <label htmlFor={subKey.sid} className="proctor-type-subcategory-label">{subKey.title}</label>

                                    {/* If enabled-default, add to the proctor types for the exam */}
                                    {this.handleEnabledDefault(subKey)}

                                    <input
                                      type="checkbox"
                                      id={subKey.sid}
                                      className="switch-input"
                                      value={subKey.sid}
                                      defaultChecked={
                                        this.state.configuration.proctorTypes.indexOf(subKey.sid) > -1 ||
                                        subKey.status === 'required' ||
                                        (subKey.status === 'enabled-default' && this.props.newExam)
                                      }
                                      onChange={(e) => {this.handleProctorType(e)}}
                                      disabled={subKey.status === 'required' || this.props.readonly}
                                      ref={(input) => this[subKey.sid] = input}
                                      onKeyDown={handleSwitchInputKeys}
                                    />

                                    <label className="switch-label" htmlFor={subKey.sid}>
                                      <span className="meta">{subKey.title}</span>
                                    </label>

                                    {this.props.renderDefault('configuration.proctorTypes', null, true, subKey.sid)}

                                    {/* If this is an instuctor field, include the location form */}
                                    {
                                      this.renderLocations(
                                        subKey.sid === config.instructorProctorTypeSid
                                      )
                                    }

                                    {/* If automated, include the settings view */}
                                    {
                                      config.automatedProctorTypeSids.indexOf(subKey.sid) > -1 &&
                                      (
                                        this.state.configuration.proctorTypes.indexOf(subKey.sid) > -1 ||
                                        subKey.status === 'required'
                                      ) &&

                                      this.renderAutomatedSettings(subKey.sid)
                                    }
                                  </li>
                                )
                              }
                            }
                        )}
                      </ul>
                    </div>
                  )
                }

                return '';
              }
            )}
          </fieldset>
        )
      }
    } else {
      // Cross listed students can't have their proctor types edited
      return (
        <fieldset>
          <p className="note note--prominent">
            {translation.cross_listed.proctors_note.replace('%school%', this.props.parentSchool.name)}
          </p>

          <ProctorGroupList
            proctorGroups={this.props.parentSchool.proctorGroups}
            noExpand={true}
            {...this.props}
          />
        </fieldset>
      )
    }

    return  null;
  }
})

export default translate('EditProctorSettings')(EditProctorSettings);



// WEBPACK FOOTER //
// ./src/app/components/ExamEdit/EditProctorSettings.js